<template>
  <div class="transactions">
    <n-grid :cols="1" :y-gap="16">
      <n-grid-item>
        <n-space justify="end">
          <n-button @click="showImport = !showImport">
            {{ showImport ? 'Masquer l\'import' : '📄 Importer une facture' }}
          </n-button>
        </n-space>
      </n-grid-item>

      <n-grid-item v-if="showImport">
        <InvoiceImport @saved="onInvoiceSaved" />
      </n-grid-item>

      <n-grid-item>
        <TransactionManagement ref="mgmt" />
      </n-grid-item>

      <n-grid-item>
        <TransactionCategoryChart />
      </n-grid-item>
    </n-grid>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import TransactionManagement from '../components/TransactionManagement.vue';
import TransactionCategoryChart from '../components/TransactionCategoryChart.vue';
import InvoiceImport from '../components/InvoiceImport.vue';

const showImport = ref(false);
const mgmt = ref(null);

const onInvoiceSaved = () => {
  showImport.value = false;
};
</script>
